module.exports = __webpack_public_path__ + "static/img/v74DetailImg.21914e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v74DetailImg.png
// module id = 8usW
// module chunks = 1